import { useSnapshot } from 'valtio'

import { type ReactElement } from 'react'
import { virtualTerminalProxy } from '../../../virtualTerminalProxy'
import {
  VirtualTerminalProxyFormFieldNamesEnum
} from '../../../../../../../shared/types/virtualTerminalProxyFormFieldNamesEnum'
import { handleBlur, handleChange } from '../utils'
import { countryCodes, usStates } from '../../../../../../../shared/utils/addressUtils'
import { toTitleCase } from '../../../../../../../shared/utils/formattingUtils'
import { NoErrorInput } from '../../../../../../../shared/components/ui/forms/NoErrorInput'

export default function AddressOverride (): ReactElement {
  const { customer, form: { values } } = useSnapshot(virtualTerminalProxy, { sync: true })

  return (
    <>

      <div className="grid grid-cols-2 my-4">
        <div className="flex ">
          <NoErrorInput
            label="Service Address"
            placeholder="123 Easy Street"
            value={values.streetAddressOne as string || ''}
            onChange={handleChange(VirtualTerminalProxyFormFieldNamesEnum.StreetAddressOne)}
            onBlur={handleBlur(VirtualTerminalProxyFormFieldNamesEnum.StreetAddressOne)}
          />
        </div>

        <div className="flex ">
          <NoErrorInput
            label="Service Address 2"
            placeholder="Apt, Suite, etc"
            value={values.streetAddressTwo as string || ''}
            onChange={handleChange(VirtualTerminalProxyFormFieldNamesEnum.StreetAddressTwo)}
            onBlur={handleBlur(VirtualTerminalProxyFormFieldNamesEnum.StreetAddressTwo)}
          />
        </div>

        <div className="flex ">
          <NoErrorInput
            label="City"
            value={values.city as string || ''}
            onChange={handleChange(VirtualTerminalProxyFormFieldNamesEnum.City)}
            onBlur={handleBlur(VirtualTerminalProxyFormFieldNamesEnum.City)}
          />
        </div>

        <div className="flex">
          <div className="flex flex-col w-full mx-2 my-1">
            <label>State</label>
            <div className="relative">
              <select
                className="py-2 pl-3 text-left w-full  border border-wpy-gray rounded-md"
                onChange={handleChange(VirtualTerminalProxyFormFieldNamesEnum.State)}
                onBlur={handleBlur(VirtualTerminalProxyFormFieldNamesEnum.State)}
                value={values.state as string || ''}
                required
              >
                <option value="" disabled>{customer?.state}</option>
                <option value="" disabled>Choose State</option>
                {
                  usStates.map(s => (
                    <option key={s.name} value={s.abbreviation}>{toTitleCase(s.name)}</option>)
                  )
                }
              </select>

            </div>
          </div>
        </div>

        <div className="flex ">
          <NoErrorInput
            label="Zip / Postal Code"
            value={values.postalCode as string || ''}
            onChange={handleChange(VirtualTerminalProxyFormFieldNamesEnum.PostalCode)}
            onBlur={handleBlur(VirtualTerminalProxyFormFieldNamesEnum.PostalCode)}
          />
        </div>

        <div className="flex">
          <div className="flex flex-col w-full mx-2 my-1">
            <label>Country</label>
            <div className="relative">
              <select
                className="py-2 pl-3 text-left w-full  border border-wpy-gray rounded-md"
                onChange={handleChange(VirtualTerminalProxyFormFieldNamesEnum.CountryCode)}
                onBlur={handleBlur(VirtualTerminalProxyFormFieldNamesEnum.CountryCode)}
                value={values.countryCode as string || ''}
                required
              >
                <option value="" disabled>Choose Country</option>
                {
                  countryCodes.map(s => (
                    <option key={s.name} value={s.abbreviation}>{toTitleCase(s.name)}</option>)
                  )
                }
              </select>
            </div>
          </div>

        </div>

        <div className="flex col-span-2 ">
          <NoErrorInput
            label="Email"
            value={values.email as string || ''}
            onChange={handleChange(VirtualTerminalProxyFormFieldNamesEnum.Email)}
            onBlur={handleBlur(VirtualTerminalProxyFormFieldNamesEnum.Email)}
          />
        </div>

      </div>
    </>
  )
}
